import { ProductContext } from './../context/ProductProvider';
import { useContext } from 'react';

export const useProduct = () => {
    return useContext(ProductContext);
};
